/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/prefer-single-boolean-return */
export const validateObject = (val: any) => {
    if (val !== undefined && val !==null && val !== '') {
        return true;
    }
    else {
        return false;
    }
}